import React, { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const initialState = [];

const BreadcrumbsData = createContext();

const BreadcrumbsDataProvider = ({ children }) => {
  const [breadcrumbData, setBreadcrumbData] = useState(initialState);

  const contextValue = useMemo(
    () => ({
      setBreadcrumbData,
      breadcrumbData,
    }),
    [breadcrumbData],
  );

  return <BreadcrumbsData.Provider value={contextValue}>{children}</BreadcrumbsData.Provider>;
};

export const useBreadcrumbsData = () => useContext(BreadcrumbsData);

BreadcrumbsDataProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BreadcrumbsDataProvider;
